import React, {FC} from "react"
import {MarkdownAtomType} from "../../model/markdown/MarkdownText"

interface AtomSeparatorProps {
    separator?: React.ReactNode
    index: number
    count: number
    current: MarkdownAtomType
    next: MarkdownAtomType
}

export const AtomSeparator: FC<AtomSeparatorProps> = ({
                                                   separator,
                                                   index,
                                                   count,
                                                   next,
                                                   current
                                               }) => {
    if (!separator || index >= count - 1 || next !== MarkdownAtomType.PLAIN) {
        return null
    }
    if (current !== MarkdownAtomType.PLAIN) {
        return null
    }

    return (
        <>
            {separator}
        </>
    )
}
